import { colors } from "../../constants/colors";

export const styles = {
  toolbar: {
    display: "flex",
    justifyContent: "space-between",
  },
  toolbarRight: {
    display: "flex",
    alignItems: "center",
    "& > *": { mx: 1 },
    "& .MuiIconButton-root": {
      padding: "16px",
      margin: "0 4px",
      "& .MuiSvgIcon-root": {
        fontSize: "2rem",
      },
    },
  },
  menuPaper: {
    maxHeight: 300,
    width: 320,
  },
  notificationMenuItem: (read) => ({
    backgroundColor: read ? "inherit" : colors.blue_green[800],
    "&:hover": {
      backgroundColor: read ? "action.hover" : colors.blue_green[700],
    },
    borderLeft: read ? "none" : `4px solid ${colors.blue_green.DEFAULT}`,
    mb: 0.5,
    whiteSpace: "normal",
    minHeight: "unset",
    py: 1.5,
  }),
  notificationContent: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    wordBreak: "break-word",
  },
  notificationText: (read) => ({
    fontWeight: read ? "normal" : "500",
    color: read ? colors.prussian_blue.DEFAULT : colors.blue_green.DEFAULT,
    lineHeight: 1.4,
  }),
  notificationDate: {
    mt: 0.5,
    color: colors.prussian_blue[300],
  },
  creditMenuPaper: {
    width: 350,
    p: 2,
  },
  creditBalanceContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    backgroundColor: colors.caribbean_current[600],
    padding: 2,
    borderRadius: 2,
  },
  creditBalanceTitle: {
    color: colors.white.DEFAULT,
    fontWeight: "bold",
  },
  creditIcon: {
    color: colors.white.DEFAULT,
  },
  creditBalanceAmount: {
    color: colors.white.DEFAULT,
    fontWeight: "bold",
  },
  creditCostContainer: {
    p: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "flex-start",
    backgroundColor: colors.caribbean_current[900],
    padding: 2,
    borderRadius: 2,
  },
  creditBalanceContent: {
    display: "flex",
    alignItems: "center",
    gap: 1,
  },
  stripeButtonContainer: {
    p: 1,
    pl: 2,
    pr: 2,
    m: 1,
    display: "flex",
    justifyContent: "center",
    "& stripe-buy-button": {
      width: "100%",
      display: "flex",
      justifyContent: "center",
    },
  },
};
